import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

const ReusableDataTable = ({
  data,
  columns,
  search,
  pagination,
  insertRow,
  deleteRow,
  loading,
  noDataMessage,
  remote,
  totalSize,
  currentPage,
  perPage,
  onPageChange,
  onSizePerPageChange,
  onSearchChange,
  showCheckbox = false,
  selectRow,
}) => {
  const options = {
    noDataText: loading ? 'Loading...' : noDataMessage || 'No data found',
    ...(remote && {
      page: currentPage,
      sizePerPage: perPage,
      onPageChange: (page) => {
        console.log('Page changed to:', page);
        onPageChange(page);
      },
      onSizePerPageList: (sizePerPage) => {
        console.log('Size per page changed to:', sizePerPage);
        onSizePerPageChange(sizePerPage);
      },
      sizePerPageList: [
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
      ],
      onSearchChange: (searchText,) => {
        console.log('Search text:', searchText);
        if (onSearchChange) {
          onSearchChange(searchText);
        }
      },
    }),
  };
  const selectRowProps = {
  mode: "checkbox",
  clickToSelect: true,
  bgColor: "#f5f5f5",

  onSelect: (row, isSelected) => {
    console.log("Selected Row:", row, isSelected);
  },

  onSelectAll: (isSelected, rows) => {
    console.log("Select All:", isSelected, rows);
  },

  ...(selectRow || {}),
};

  return (
<div className="table-x-scroll">
    <BootstrapTable
      striped
      hover
      condensed
      search={search}
      data={data}
      deleteRow={deleteRow}
      pagination={pagination}
      insertRow={insertRow}
      options={options}
      tableHeaderClass="mb-0"
      remote={remote}
      fetchInfo={{ dataTotalSize: totalSize }}
      nowrap
      {...(showCheckbox ? { selectRow: selectRowProps } : {})}
    >
      {columns.map((column) => (
        // <TableHeaderColumn
        //   key={column.dataField}
        //   dataField={column.dataField}
        //   isKey={column.isKey || false}
        //   width={column.width || '150'}
        //   dataFormat={column.formatter}
        // >
        //   {column.text}
        // </TableHeaderColumn>
        <TableHeaderColumn
          key={column.dataField}
          dataField={column.dataField}
          isKey={column.isKey || false}
          width={column.width || '150'}
          dataFormat={column.formatter}
          hidden={column.hidden || false}
        >
          {column.text}
        </TableHeaderColumn>
      ))}
    </BootstrapTable>
    </div>
  );
};

ReusableDataTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      dataField: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      isKey: PropTypes.bool,
      width: PropTypes.string,
      formatter: PropTypes.func,
    }),
  ).isRequired,
  search: PropTypes.bool,
  pagination: PropTypes.bool,
  insertRow: PropTypes.bool,
  deleteRow: PropTypes.bool,
  loading: PropTypes.bool,
  noDataMessage: PropTypes.string,
  remote: PropTypes.bool,
  totalSize: PropTypes.number,
  currentPage: PropTypes.number,
  perPage: PropTypes.number,
  onPageChange: PropTypes.func,
  onSizePerPageChange: PropTypes.func,
  onSearchChange: PropTypes.func,
   selectRow: PropTypes.object,
   showCheckbox: PropTypes.bool,
};

ReusableDataTable.defaultProps = {
  search: true,
  pagination: true,
  insertRow: false,
  deleteRow: false,
  loading: false,
  noDataMessage: 'No data found',
  remote: false,
  totalSize: 0,
  currentPage: 1,
  perPage: 10,
  onPageChange: () => {},
  onSizePerPageChange: () => {},
  onSearchChange: null,
};

export default ReusableDataTable;
